import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/************************************* 二级品牌 -- begin *************************************/
/**
 * 获取二级品牌审核列表
 * @returns 
 */
export const getSecondBrandCheckListApi = (params: object = {}) => $http.get('/brand/check_secondary_brands_list', params)
/**
 * 获取二级品牌列表 is_page：2-不分页
 */
export const getSecondBrandListApi = (params: object = {}) => $http.get('/brand/secondary_brands_list', params)
/**
 * 获取二级品牌列表-不分页
 */
export const getSecondBrandListNoPageApi = (brand_id: string) => $http.get('/brand/secondary_brands', { brand_id })
/**
 * 获取二级品牌详情
 * @param params
 * @returns
 */
export const getSecondBrandDetailApi = (params: object = {}) => $http.get('/brand/secondary_brands_details', params)
/**
 * 修改二级品牌上下架状态
 * id：供应商二级品牌id
 * secondary_id：平台二级品牌id
 */
export const updateSecondBrandStatusApi = (id, secondary_id, status) => $http.post('/brand/secondary_brands_status', { id, secondary_id, status })
/**
 * 保存二级品牌
 * @param params submit_type：1-保存本地，2-提交审核
 * @returns 
 */
export const saveSecondBrandApi = (data: object = {}) => $http.post('/brand/apply_secondary_brands', data)
/**
 * 撤回/删除审核记录
 * @param params check_id：审核记录ID
 * @param params is_type：1-撤回 2-删除
 * @returns 
 */
export const cancelOrDelSecondBrandApi = (check_id: number, is_type: number) => $http.get('/brand/secondary_brands_del', { check_id, is_type })
/**
 * 二级品牌审核
 * @param params check_id：审核记录ID
 * @param params check_status：1-审核通过 2-驳回
 * @param params secondary_id：关联平台二级品牌ID
 * @param params remark：驳回原因
 * @returns 
 */
export const checkSecondBrandApi = (data: object) => $http.post('/brand/secondary_brands_check', data)
/************************************* 二级品牌 -- end *************************************/

/************************************* 投诉订单 -- begin *************************************/
/**
 * 获取投诉订单列表
 */
export const getComplaintOrderListApi = (params: object = {}) => $http.get('/help/get_help_order_list', params)
/**
 * 根据订单号获取订单详情
 */
export const getOrderDetailApi = (order_id: string) => $http.get('/help/get_product_info', { order_id })
/**
 * 新增投诉订单
 */
export const saveComplaintOrderApi = (data: object) => $http.post('/help/add_help_order', { help_info: data })
/************************************* 投诉订单 -- end *************************************/

/************************************* 电子券 -- begin *************************************/
/**
 * 获取电子券商品详情
 */
export const getCouponProductDetailApi = (params: object = {}) => $http.get('/cake_api/get_couponproduct_info', params)

/**
 * 编辑电子券商品
 */
export const editCouponProductApi = (data: object = {}) => $http.post('/cake_api/up_couponproduct', data)
/************************************* 电子券 -- end *************************************/
